import React, { useState } from "react";
import SettingsIcon from "@mui/icons-material/Settings";
import ShoppingBasketIcon from "@mui/icons-material/ShoppingBasket";
import EmailIcon from "@mui/icons-material/Email";
import TelegramIcon from "@mui/icons-material/Telegram";

export const ProducerMenuItems = [
  // {
  //   header: "تنظیمات",
  //   headerIcon: SettingsIcon,
  //   items: [
  //     {
  //       name: "تنظیمات نمایش",
  //       route: "/setting-set-parameter",
  //       isActive: "parameter",
  //     },
  //   ],
  // },
  {
    header: "تنظیمات",
    headerIcon: SettingsIcon,
    items: [],
    route: "/setting-set-parameter",
  },
  {
    header: "سفارش‌ها",
    headerIcon: ShoppingBasketIcon,
    items: [
      {
        name: "سفارش‌های جدید",
        route: "/p-new-orders",
        isActive: "p-new-orders",
      },

      {
        name: "سفارش‌های جاری",
        route: "/p-progress-orders",
        isActive: "p-progress-orders",
      },
      {
        name: "سفارش‌های منتظر تایید",
        route: "/p-need-confirmed-orders",
        isActive: "p-need-confirmed-orders",
      },
      {
        name: "سفارش‌های تحویل داده‌شده",
        route: "/p-delivered-orders",
        isActive: "p-delivered-orders",
      },
     
    ],
  },

  {
    header: "پیام رسان",
    headerIcon: EmailIcon,
    items: [],
    route: "/messages",
  },
  {
    header: "گفتگوها",
    headerIcon: TelegramIcon,
    items: [],
    route: "/chats",
    haveBadge: true,
  },
];
